// Lib Imports
import React, { useEffect, useState } from 'react';
import { Box, Stack, Text } from 'grommet';
import styled from 'styled-components';
import { Bell } from '@styled-icons/fa-solid/Bell';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';

// Core Imports
import DropMenu from 'granite-admin/core/components/DropMenu';
import useWebSocket from 'granite-admin/utils/useWebSocket';
import useNotificationsCount from 'granite-admin/utils/useNotificationsCount';
import { withTheme, createGlobalStyle } from 'styled-components';
import { fetchNotifications } from 'granite-admin/common/gateways/notification-api';
import NotificationStack from './components/NotificationStack';
const GlobalStyles = createGlobalStyle`
  .notification-drop {
    max-width:325px;
    left: ${({
  isCollapsed,
  sideBarWidth
}) => `${isCollapsed ? `58px` : sideBarWidth} !important;`}
    right:auto !important;
  }
  .notification-drop-right {
    max-width:325px;
    left:auto !important;
    right: ${({
  isCollapsed,
  sideBarWidth
}) => `${isCollapsed ? `58px` : sideBarWidth} !important;`}
  }
`;
const StyledMenu = styled(DropMenu)`
  &:hover svg {
    color: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-svg-hover'] + `!important`};
  }
  &:hover .bell-count {
    background: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-svg-hover'] + `!important`};
  }
  &:hover .bell-count span {
    color: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-icon'] + `!important`};
  }
  &:hover span {
    color: ${({
  isActive,
  theme
}) => theme.global.colors['sidebar-label-hover'] + `!important`};
  }
`;
const AnimationBox = styled(Box)`
  ${({
  animatedIcon
}) => {
  if (animatedIcon) return `
    animation: shake 5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;

  @-webkit-keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }`;
}}
`;
const Notification = ({
  isCollapsed,
  sidebarPosition,
  hoverIndicatorOptions,
  config
}) => {
  const history = useHistory();
  const {
    handleFetchNotificationCount,
    handleCountOnNotificationClick,
    handleMarkAllReadClick,
    notificationsCount
  } = useNotificationsCount();
  const [notifications, setNotifications] = useState([]);
  // const [count, setCount] = useState();
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState();
  const [animatedIcon, setAnimatedIcon] = useState(false);
  const [isRead, setIsRead] = useState(null);
  const {
    websocketMappings = null
  } = config || {};
  useEffect(() => {
    if (!websocketMappings || !websocketMappings['NOTIFICATION']) {
      handleFetchNotificationCount();
      const intervalId = setInterval(handleFetchNotificationCount, 1000 * 60);
      return () => clearInterval(intervalId);
    }
  }, [handleFetchNotificationCount, websocketMappings]);
  const handleFetchNotifications = isReadParam => {
    setLoader(true);
    let mypage;
    if (isReadParam === 'FETCH_UNREAD_ONSCROLL') {
      mypage = page;
      isReadParam = false;
    } else if (isReadParam === 'FETCH_UNREAD_ONCE') {
      setPage(1);
      mypage = 1;
      setNotifications([]);
      isReadParam = false;
    } else if (isReadParam === 'FETCH_ALL_NOTIFICATION') {
      mypage = 1;
      isReadParam = null;
    } else {
      mypage = page;
      isReadParam = null;
    }
    if (mypage == null) mypage = 1;
    fetchNotifications(mypage, isReadParam).then(response => {
      if (page === 1) setNotifications(response.list);else setNotifications(notifications => _.uniqBy([...notifications, ...response.list], 'pk'));
      setPage(response.nextPage);
      setLoader(false);
    }).catch(() => setLoader(false));
  };

  // const handleFetchNotificationCount = () => {
  //   fetchNotificationCount()
  //     .then(res => setCount(res.count))
  //     .catch(err => console.log(err));
  // };

  const handleNotificationClick = notification => {
    if (!notification.status) {
      handleCountOnNotificationClick(notification.pk);
      setNotifications(prev => prev.map(i => ({
        ...i,
        status: i.pk === notification.pk ? true : i.status
      })));
      // handleFetchNotificationCount();
      // setCount(prev => prev - 1);
    }

    if (notification.url !== '') history.push(notification.url);
  };
  const markAllRead = () => {
    handleMarkAllReadClick();
    setNotifications(prev => prev.map(i => ({
      ...i,
      status: true
    })));
    setOpen(false);
  };
  const showUnread = showUnread => {
    if (showUnread !== 'FETCH_ALL') {
      setIsRead('FETCH_UNREAD_ONCE');
      handleFetchNotifications('FETCH_UNREAD_ONCE');
    } else {
      setIsRead(null);
      handleFetchNotifications('FETCH_ALL_NOTIFICATION');
    }
    setOpen(false);
  };
  function onGetMessage(eventData) {
    if (websocketMappings && websocketMappings[eventData.action]) {
      handleFetchNotificationCount(notificationsCount + 1);
      setAnimatedIcon(true);
    }
  }
  useWebSocket({
    onGetMessage
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    isCollapsed: isCollapsed,
    sideBarWidth: config?.sidebarSettings?.width
  }), /*#__PURE__*/React.createElement(StyledMenu, {
    icon: /*#__PURE__*/React.createElement(AnimationBox, {
      animatedIcon: animatedIcon,
      onAnimationEnd: () => setAnimatedIcon(false)
    }, /*#__PURE__*/React.createElement(Stack, {
      anchor: "top-right",
      className: "stack"
    }, /*#__PURE__*/React.createElement(Bell, {
      size: "20px",
      color: 'sidebar-icon'
    }), notificationsCount && /*#__PURE__*/React.createElement(Box, {
      className: "bell-count",
      flex: "grow",
      background: "sidebar-icon",
      width: "10px",
      height: "10px",
      align: "center",
      justify: "center",
      round: "full",
      margin: {
        left: '2rem'
      },
      border: {
        size: '1px',
        color: 'brand'
      },
      pad: "0.4rem"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "9px",
      color: "sidebar-label-hover"
    }, notificationsCount > 9 ? '9+' : notificationsCount)))),
    isCollapsed: isCollapsed,
    label: /*#__PURE__*/React.createElement(Text, null, "Notifications"),
    dropProps: {
      className: sidebarPosition === 'right' ? 'notification-drop-right' : 'notification-drop',
      style: {
        backgroundColor: '#fff',
        transition: 'all 0.5s ease 0s',
        borderRadius: '3px',
        boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 17px 6px'
      }
    },
    dropAlign: {
      bottom: 'bottom'
    },
    onClose: () => {
      setPage(1);
      setNotifications([]);
      setIsRead(null);
      setOpen(false);
    },
    onOpen: handleFetchNotifications,
    renderItems: () => /*#__PURE__*/React.createElement(NotificationStack, {
      notifications: notifications,
      loader: loader,
      handleNotificationClick: handleNotificationClick,
      setPage: setPage,
      page: page,
      handleFetchNotifications: handleFetchNotifications,
      hoverIndicatorOptions: hoverIndicatorOptions,
      markAllRead: markAllRead,
      showUnread: showUnread,
      isRead: isRead,
      setOpen: setOpen,
      open: open,
      showSkeletonLoader: config?.showSkeletonLoader
    }),
    hoverIndicatorOptions: hoverIndicatorOptions
  }));
};
Notification.propTypes = {
  isCollapsed: PropTypes.bool,
  sidebarPosition: PropTypes.string,
  hoverIndicatorOptions: PropTypes.object
};
export default withTheme(Notification);